import Snackbar from 'components/snackbar/snackbar.component';
import { SnackbarProvider, SnackbarProviderProps } from 'notistack';
import './inc-snackbar-provider.css';

export type IncSnackbarProviderProps = {
  children: React.ReactNode;
} & Partial<SnackbarProviderProps>;

const IncSnackbarProvider = ({
  children,
  ...rest
}: IncSnackbarProviderProps) => {
  return (
    <SnackbarProvider
      maxSnack={3}
      anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
      Components={{ alert: Snackbar }}
      variant="alert"
      classes={{ root: 'inc-root-notistack' }}
      {...rest}
    >
      {children}
    </SnackbarProvider>
  );
};

export default IncSnackbarProvider;
